import { getDepartmentsForContext } from '../constants/departments';

export const COMPARE_MEMBERSHIPS = ['Newbie', 'Junior', 'Senior'];

export const membershipColors = {
  Newbie: '#b87333',
  Junior: '#818181ff',
  Senior: '#c9a227',
};

export const departmentOptions = getDepartmentsForContext('filters').map((dept) => ({
  value: dept.name,
  label: dept.name,
}));

export const emptyCompareFilters = () => ({
  sardines: [],
  departments: [],
  memberships: [],
});

export function parseCompareFiltersFromSearch(search) {
  const params = new URLSearchParams(search);
  return {
    sardines: params.get('sardines')?.split(',').filter(Boolean) || [],
    departments: params.get('departments')?.split(',').filter(Boolean) || [],
    memberships: params.get('memberships')?.split(',').filter(Boolean) || [],
  };
}

export function buildCompareFiltersSearch(filters) {
  const params = new URLSearchParams();
  if (filters.sardines.length) {
    params.set('sardines', filters.sardines.join(','));
  }
  if (filters.departments.length) {
    params.set('departments', filters.departments.join(','));
  }
  if (filters.memberships.length) {
    params.set('memberships', filters.memberships.join(','));
  }
  return params.toString();
}

export function userMatchesBulkFilters(user, departments, memberships) {
  const matchesDepartment =
    departments.length === 0 ||
    user.departments?.some((dept) => departments.includes(dept));
  const matchesMembership =
    memberships.length === 0 ||
    memberships.includes(user.membershipType);

  return matchesDepartment && matchesMembership;
}

export function getUsersMatchingBulkFilters(allUsers, departments, memberships) {
  return allUsers
    .filter((user) => userMatchesBulkFilters(user, departments, memberships))
    .map((user) => user._id);
}

export function hasBulkFilterCriteria(filters) {
  return filters.departments.length > 0 || filters.memberships.length > 0;
}

export function resolveSardinesFromFilters(filters, users, { previousHadBulk = false } = {}) {
  if (hasBulkFilterCriteria(filters)) {
    return getUsersMatchingBulkFilters(users, filters.departments, filters.memberships);
  }
  if (previousHadBulk) {
    return [];
  }
  return filters.sardines;
}

export function applyDepartmentChange(selectedOptions, filters, users) {
  const newDepartments = selectedOptions ? selectedOptions.map((option) => option.value) : [];
  const previousHadBulk = hasBulkFilterCriteria(filters);
  const nextFilters = {
    departments: newDepartments,
    memberships: filters.memberships,
    sardines: filters.sardines,
  };

  return {
    ...nextFilters,
    sardines: resolveSardinesFromFilters(nextFilters, users, { previousHadBulk }),
  };
}

export function applyMembershipToggle(membership, filters, users) {
  const newMemberships = filters.memberships.includes(membership)
    ? filters.memberships.filter((mem) => mem !== membership)
    : [...filters.memberships, membership];
  const previousHadBulk = hasBulkFilterCriteria(filters);

  const nextFilters = {
    departments: filters.departments,
    memberships: newMemberships,
    sardines: filters.sardines,
  };

  return {
    ...nextFilters,
    sardines: resolveSardinesFromFilters(nextFilters, users, { previousHadBulk }),
  };
}

export function applySardinesChange(selectedOptions, filters) {
  return {
    ...filters,
    sardines: selectedOptions ? selectedOptions.map((option) => option.value) : [],
  };
}

export function getMembershipCounts(users, departments = []) {
  return COMPARE_MEMBERSHIPS.reduce((counts, membership) => {
    counts[membership] = users.filter(
      (user) => user.membershipType === membership && userMatchesBulkFilters(user, departments, [membership]),
    ).length;
    return counts;
  }, {});
}
